/* eslint-disable */
import { ReactElement, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Avatar, Dropdown, Menu, Button } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import firebase from "firebase/app";
import ls from "local-storage";
import { useTranslation } from "react-i18next";
import { LOGOUT_USER_REQUEST, CHNAGE_LANGUAGE } from "../redux/constants";
import { LogoutButton, SPHeader, FullNameText } from "./GlobalStyles";
import { getAuthState, getAppState } from "../redux/selectors";

export function Header(): ReactElement {
  const history = useHistory();
  const dispatch = useDispatch();
  const { currentUser } = useSelector(getAuthState);
  const { locale } = useSelector(getAppState);
  const [visible, setVisible] = useState(false);
  const { t, i18n } = useTranslation();

  const logout = async () => {
    ls("user", null);
    await firebase.auth().signOut();
    dispatch({ type: LOGOUT_USER_REQUEST });
    history.push("/login");
  };

  const goProfile = () => {
    history.push("/profile");
    setVisible(false);
  };

  const handleVisibleChange = () => {
    setVisible(!visible);
  };

  const menu = (
    <Menu>
      <Menu.Item key="1" icon={<UserOutlined />} onClick={goProfile}>
        <LogoutButton type="text">Profile</LogoutButton>
      </Menu.Item>
      <Menu.Item key="2" icon={<LogoutOutlined />} onClick={logout}>
        <LogoutButton type="text">Log out</LogoutButton>
      </Menu.Item>
    </Menu>
  );

  const onChangeLanguage = (code: string) => {
    dispatch({
      type: CHNAGE_LANGUAGE,
      payload : code
    })
    i18n.changeLanguage(code);
  }

  return (
    <SPHeader>
      <div className="header-language-select-container">
        <Button className="language-selector" onClick={() => onChangeLanguage(locale === "en" ? "ar" : "en")} >{t("common.language")}</Button>
      </div>
      <Dropdown
        overlay={menu}
        placement="bottomRight"
        onVisibleChange={handleVisibleChange}
        visible={visible}
        trigger={["click"]}
      >
        <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
          <Avatar src={currentUser?.photoUrl} size={30} icon={<UserOutlined />} />
          <FullNameText>{currentUser?.fullName}</FullNameText>
        </a>
      </Dropdown>
    </SPHeader>
  );
}
